import { Link } from "react-router-dom";
import { ROUTES } from "@/config/routes";
import { site } from "@/config/site";

export function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="web-site-foot flex flex-wrap items-center justify-between gap-2 border-t border-[var(--border-soft)] bg-[var(--surface)] px-7 py-3.5 text-[0.78rem] text-[var(--muted)]">
      <span className="flex flex-wrap gap-2">
        <Link to={ROUTES.privacy} className="font-semibold hover:text-[var(--accent)]">
          Privacy
        </Link>
        <span>·</span>
        <Link to={ROUTES.terms} className="font-semibold hover:text-[var(--accent)]">
          Terms
        </Link>
        <span>·</span>
        <a
          href={`mailto:${site.supportEmail}`}
          className="font-semibold hover:text-[var(--accent)]"
        >
          Contact
        </a>
        <span>·</span>
        <Link to={ROUTES.help} className="font-semibold hover:text-[var(--accent)]">
          Help
        </Link>
      </span>
      <span>© {year} {site.brandName}</span>
    </footer>
  );
}
